// extracted by mini-css-extract-plugin
module.exports = {"message":"ExternalNurseryErrorDialog_message__3cW7s"};